export function reportstatMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportstatId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateReportstatId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateReportstatId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyReportstat(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      reportstatId: resource.objectId,
    })),
  };
}

export function reportstatMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, reportstatId: json.result.objectId},
  };
}